module.exports = __webpack_public_path__ + "static/DarksideDetective4-6ad3de52295acc18e7ecf3dcb1533472.webp";